import { useEffect, useState } from 'react'
import { splitRemaining, type Remaining } from '../utils/schedule'

/** Ticks once a second while `target` is in the future. */
export function useCountdown(target: number | null): Remaining {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (target === null) return
    setNow(Date.now())
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [target])

  return splitRemaining(target === null ? 0 : target - now)
}
